import {RepositoryFactory} from "../../scripts/RepositoryFactory";
import Vue from 'vue';
import moment from 'moment';
import Utils from '../../scripts/utils';

const TrackingRepository = RepositoryFactory.get('trackingLists');

const state = {
    data: {
        medium: {
            insertion_order: []
        }
    },
    columns:
        [
            {
                viewName: 'Name',
                propName: '',
                width: '230px'
            },
            {
                viewName: 'Technischer Name',
                propName: '',
                width: '280px'
            },
            {
                viewName: 'Status',
                propName: '',
                width: '110px'
            },
            {
                viewName: 'Bemerkung',
                propName: '',
                width: '200px'
            },
            {
                viewName: 'Aktion',
                propName: '',
                width: '80px'
            },
            {
                viewName: 'Beschreibung',
                propName: '',
                width: '290px'
            }
        ],
    currentRoute: '',
    reportingAdded: true,
    containerHeight: 0,
    reportingData: null,
    db_status: ['in Arbeit', 'gecheckt', 'eingebaut', 'nicht eingebaut'],
    tableClientRect: null,
    contentContainerRect: null,
    kpiStyles: {
        kpi_even: {
            width: '200px',
            height: '100px',
            background: '#f7f7f9'
        },
        kpi_odd: {
            width: '200px',
            height: '100px',
            background: '#d0d4da'
        },
        kpiIcon: {
            position: 'absolute',
            right: '2px',
            top: 0,
            bottom: 0,
            'margin-top': 'auto',
            'margin-bottom': 'auto',
            height: '12px'

        },
    },
    dashboard: {
        firstColWidth: '300px',
        cache: []
    },
    formulaStandardEvents: [
        {
            name: 'Video gestartet',
            dividend: 'video_started',
            divisor: 'video_started',
            selected: false,
            description: 'Video wurde gestartet'
        },
        {
            name: 'Video 25% gesehen',
            dividend: 'video_25p_viewed',
            divisor: 'video_started',
            selected: false,
            description: 'Video wurde zu 25% angesehen (im Verhältnis zu den Videostarts)'
        }, {
            name: 'Video 50% gesehen',
            dividend: 'video_50p_viewed',
            divisor: 'video_started',
            selected: false,
            description: 'Video wurde zu 50% angesehen (im Verhältnis zu den Videostarts)'
        }, {
            name: 'Video 75% gesehen',
            dividend: 'video_75p_viewed',
            divisor: 'video_started',
            selected: false,
            description: 'Video wurde zu 75% angesehen (im Verhältnis zu den Videostarts)'
        }, {
            name: 'Video 100% gesehen',
            dividend: 'video_100p_viewed',
            divisor: 'video_started',
            selected: false,
            description: 'Video wurde zu 100% angesehen (im Verhältnis zu den Videostarts)'
        }, {
            name: 'Expand Rate',
            dividend: '_expand',
            divisor: 'totalAIs',
            selected: false,
            description: 'Ausgelöste Expands (durch Autostart und Klicks)'
        }, {
            name: 'Expand Time',
            dividend: 'expand_keepAlive',
            divisor: 'expand_timerStarted',
            selected: false,
            description: 'Zeit, die die User den Expand geöffnet hatten. Alles über 10 Sekunden wird aus technischen Gründen nicht mitgemessen.'
        }, {
            name: 'Heavy User im Expand',
            dividend: 'expand_keepAliveFinish',
            divisor: '_expand',
            selected: false,
            description: 'Anzahl der User, die den Expand länger als 10 Sekunden geöffnet hatten (im Verhältnis zu den Expands)'
        }
    ],
    changesMade: false,
    showCommentSection: false,
    initialStatus: null,
    reporting_loading: false,
};

// getters
const getters = {
    campaign: (state) => {
        let ret = {};
        if (Object.keys(state.data).length !== 0) {
            for (let key in state.data.medium.campaign) {
                if (key === "ad_special") {
                    ret.ad_special = state.data.medium.campaign[key].name;
                } else if (key !== "ad_special_id") {
                    ret[key] = state.data.medium.campaign[key];
                }
            }
            ret.id = state.data.medium.campaign_id;
            return ret;
        }
        return null;
    },
    navBox: (state, getters, rootState) => {
        if (Object.keys(state.data).length !== 0 && Object.prototype.hasOwnProperty.call(state.data, 'medium')) {
            let ret = [
                {text: "Kampagne bearbeiten", onclick: "goTo", params: "editCampaign"},
                {text: "Platzierungen anzeigen", onclick: "openPlacementDialog"},
                {text: "zum Dashboard", onclick: "goTo", params: "showDashboard"},
            ];
            if (rootState.campaign.campaign && rootState.campaign.campaign.jira_ticket_url) {
                ret.unshift({
                    text: "zum Jira-Ticket",
                    onclick: "goTo",
                    params: rootState.campaign.campaign.jira_ticket_url
                })
            }
            return ret;
        }
        return null;
    },
    trackingList: (state) => {
        if (Object.keys(state.data).length !== 0) {
            return state.data;
        }
        return null;
    },
    accordion: (state) => {
        if (Object.keys(state.data).length !== 0) {
            let ret = [];
            ret.push({
                id: '',
                active: true,
                itemComponentName: "Space",
                itemComponentProps: {
                    modules: [],
                    interactions: state.data.interactions,
                    ignoreIndex: true
                },
                title: 'Trackinglist Interactions'
            });
            for (let i = 0; i < state.data.spaces.length; i++) {
                state.data.spaces[i].spaceIndex = i;
                let tmp = {
                    id: 'space_' + i, //index of space
                    active: true,
                    itemComponentName: "Space",
                    itemComponentProps: state.data.spaces[i],
                    disableActionIcons: false,
                    title: state.data.spaces[i].technical_name
                };
                ret.push(tmp);
            }
            return ret;
        }
        return null;
    },
    reporting: (state, getters) => {
        let ret = {};
        //let data = state.data;
        let reportingData = state.reportingData;
        if (reportingData !== null && typeof reportingData !== "undefined") {
            for (let i = 0; i < reportingData.length; i++) {
                if (reportingData[i].result) {
                    let splittedReqUrl = reportingData[i].url.split('/');
                    let hash = splittedReqUrl[splittedReqUrl.length - 3];
                    let hash_key = hash + '_' + reportingData[i].insertion_order_id;
                    //let insertionOrder = data.medium.insertion_order.find(x => x.engagement_hash === hash);
                    let earliestDate = splittedReqUrl[splittedReqUrl.length - 2];
                    let latestDate = splittedReqUrl[splittedReqUrl.length - 1].split('?')[0];
                    if (typeof ret[hash_key] === "undefined") {
                        ret[hash_key] = {
                            duration: {
                                start: earliestDate,
                                end: latestDate
                            },
                            events: {},
                            sites: {},
                            lineItems: {},
                            categories: {},
                            unusedEvents: []
                        };
                    }
                    let date_event = reportingData[i].result.date_site_zone_event;
                    for (let key in date_event) {
                        date_event[key].event = date_event[key].event.trim();
                        let tmpDate = date_event[key].dateOnly;
                        if (moment(earliestDate).isSameOrBefore(moment(tmpDate)) && moment(latestDate).isSameOrAfter(moment(tmpDate))) {
                            if (!getters.getTechnicalNames.includes(date_event[key].event)) {
                                ret[hash_key].unusedEvents.push(date_event[key].event);
                            }
                            ret[hash_key].events[date_event[key].event] = ret[hash_key].events[date_event[key].event] || 0;
                            ret[hash_key].events[date_event[key].event] += parseInt(date_event[key]['count(*)']);

                            ret[hash_key].sites[date_event[key].site] = ret[hash_key].sites[date_event[key].site] || {};
                            ret[hash_key].sites[date_event[key].site][date_event[key].event] = ret[hash_key].sites[date_event[key].site][date_event[key].event] || 0;
                            ret[hash_key].sites[date_event[key].site][date_event[key].event] += parseInt(date_event[key]['count(*)']);

                            ret[hash_key].lineItems = reportingData[i].lineItems;

                            ret[hash_key].categories[date_event[key].site] = ret[hash_key].categories[date_event[key].site] || {};
                            ret[hash_key].categories[date_event[key].site][date_event[key].zone] = ret[hash_key].categories[date_event[key].site][date_event[key].zone] || {};
                            ret[hash_key].categories[date_event[key].site][date_event[key].zone][date_event[key].event] = ret[hash_key].categories[date_event[key].site][date_event[key].zone][date_event[key].event] || 0;
                            ret[hash_key].categories[date_event[key].site][date_event[key].zone][date_event[key].event] += parseInt(date_event[key]['count(*)']);
                        }
                    }
                    ret[hash_key].unusedEvents = [...new Set(ret[hash_key].unusedEvents)];
                }
            }
        }
        return ret;
    },
    getTechnicalNames: (state) => {
        let existingEvents = [];
        state.data.spaces.forEach((space) => {
            space.interactions.forEach((interaction) => {
                existingEvents.push(space.technical_name + interaction.technical_name);
            });
            space.modules.forEach((module) => {
                module.interactions.forEach((interaction) => {
                    existingEvents.push(space.technical_name + '_' + module.technical_name + interaction.technical_name);
                })
            });
        });
        return existingEvents;
    },
    formulas: (state, getters) => {
        let ret = [];
        let data = state.data;
        if (Object.keys(getters.reporting).length !== 0) {
            let customFormulas = data.formulas.filter(x => x.id === 1);
            let standardFormulas = data.formulas.filter(x => x.id !== 1);
            customFormulas.forEach((formula) => {
                formula.name = formula.pivot.name;
                if (typeof formula.created_at === 'undefined') {
                    formula.created_at = moment().format('YYYY-MM-DD HH:mm:ss');
                }
            });
            customFormulas.sort(function (a, b) {
                return moment(a.pivot.created_at).valueOf() - moment(b.pivot.created_at).valueOf();
            });
            let reporting = getters.reporting;
            let formulas = standardFormulas.concat(customFormulas);
            for (let i = 0; i < formulas.length; i++) {
                ret.push(formulas[i]);
                if (formulas[i].id === 1 && formulas[i].pivot.dividend !== null && formulas[i].pivot.divisor) {
                    //TODO custom Formulas
                    ret[i].reporting = divideEachBy(reporting, getTotalCountOf(reporting, formulas[i].pivot.dividend, state), getTotalCountOf(reporting, formulas[i].pivot.divisor, state), null, true);
                    console.log(formulas[i].pivot.dividend, getTotalCountOf(reporting, formulas[i].pivot.dividend, state));
                    console.log(formulas[i].pivot.divisor, getTotalCountOf(reporting, formulas[i].pivot.divisor, state));

                } else {
                    switch (formulas[i].name.toLowerCase()) {
                        case 'interaction rate': //(Summe[_click]+Summe[_extclick]+Summe[_imouseover]+Summe[_alle u.a. Sonstigen Interactions])/AIs
                            ret[i].reporting = divideEachBy(reporting, getTotalCountOf(reporting, ['_click', 'totalClicks', '_imouseover', '_swipe', '_drag', '_scroll'], state), 'totalAIs', null);
                            break;
                        case 'gesamt-klickrate': //(Summe[_click])+(Summe[_extclick])/AIs
                            ret[i].reporting = divideEachBy(reporting, getTotalCountOf(reporting, ['_click', 'totalClicks'], state), 'totalAIs', null);
                            break;
                        case 'interne klickrate': //Summe[_click]/AIs
                            ret[i].reporting = divideEachBy(reporting, getTotalCountOf(reporting, '_click', state), 'totalAIs');
                            break;
                        case 'externe klickrate': //Summe[_extclick]/AIs
                            ret[i].reporting = divideEachBy(reporting, getTotalCountOf(reporting, 'totalClicks', state), 'totalAIs', null);
                            break;
                        case 'interaktiver mouseover-rate': //Summe[_imouseover]/Desktop-AIs
                            ret[i].reporting = divideEachBy(reporting, getTotalCountOf(reporting, '_imouseover', state), 'desktopAIs');
                            break;
                        case 'swipes': //Summe[__swipe]/AIs
                            ret[i].reporting = divideEachBy(reporting, getTotalCountOf(reporting, '_swipe', state), 'totalAIs');
                            break;
                        case 'drags': //Summe[_drag]/AIs
                            ret[i].reporting = divideEachBy(reporting, getTotalCountOf(reporting, '_drag', state), 'totalAIs');
                            break;
                        case 'drag und drops': //Summe[_dragndrop]/AIs
                            ret[i].reporting = divideEachBy(reporting, getTotalCountOf(reporting, '_dragndrop', state), 'totalAIs');
                            break;
                        case 'scrolls': //Summe[_scroll]/AIs
                            ret[i].reporting = divideEachBy(reporting, getTotalCountOf(reporting, '_scroll', state), 'totalAIs');
                            break;
                        case 'interaction time': //ad_keepAlive/ad_timerStarted
                            ret[i].reporting = divideEachBy(reporting, getTotalCountOf(reporting, 'ad_keepAlive', state), getTotalCountOf(reporting, 'ad_timerStarted', state), 'interaction_time');
                            break;
                        case 'heavy user': //ad_keepAliveFinish/Desktop-AIs
                            ret[i].reporting = divideEachBy(reporting, getTotalCountOf(reporting, 'ad_keepAliveFinish', state), 'desktopAIs');
                            break;
                        case 'expand rate': //Summe[_expand]/AIs
                            ret[i].reporting = divideEachBy(reporting, getTotalCountOf(reporting, '_expand', state), 'totalAIs');
                            break;
                        case 'expand time': //expand_keepAlive/expand_timerStarted
                            ret[i].reporting = divideEachBy(reporting, getTotalCountOf(reporting, 'expand_keepAlive', state), getTotalCountOf(reporting, 'expand_timerStarted', state), 'expand time');
                            break;
                        case 'heavy user im expand': //expand_keepAliveFinish/_expand
                            ret[i].reporting = divideEachBy(reporting, getTotalCountOf(reporting, 'expand_keepAliveFinish', state), getTotalCountOf(reporting, '_expand', state));
                            break;
                        case 'video gestartet': //video_started
                            ret[i].reporting = divideEachBy(reporting, getTotalCountOf(reporting, 'video_started', state), 'totalAIs');
                            break;
                        case 'video 25% gesehen': //video_25p_viewed/video_started
                            ret[i].reporting = divideEachBy(reporting, getTotalCountOf(reporting, 'video_25p_viewed', state), getTotalCountOf(reporting, 'video_started', state));
                            break;
                        case 'video 50% gesehen': //video_50p_viewed/video_started
                            ret[i].reporting = divideEachBy(reporting, getTotalCountOf(reporting, 'video_50p_viewed', state), getTotalCountOf(reporting, 'video_started', state));
                            break;
                        case 'video 75% gesehen': //video_75p_viewed/video_started
                            ret[i].reporting = divideEachBy(reporting, getTotalCountOf(reporting, 'video_75p_viewed', state), getTotalCountOf(reporting, 'video_started', state));
                            break;
                        case 'video 100% gesehen': //video_25p_viewed/video_started
                            ret[i].reporting = divideEachBy(reporting, getTotalCountOf(reporting, 'video_100p_viewed', state), getTotalCountOf(reporting, 'video_started', state));
                            break;
                    }
                }
            }
            let customFormulaSums = [];
            for (let j = 0; j < ret.length; j++) {
                let video = ret[j].name.toLowerCase().indexOf('video') !== -1;
                let expand = ret[j].name.toLowerCase().indexOf('expand') !== -1;
                if (video || expand) {
                    let notFound = true;
                    if (customFormulaSums.length > 0) {
                        for (let i = 0; i < customFormulaSums.length; i++) {
                            if (ret[j].pivot.spacename === customFormulaSums[i].pivot.spacename && ((customFormulaSums[i].name === 'expand_sum' && expand) || (customFormulaSums[i].name === 'video_sum' && video))) {
                                customFormulaSums[i][ret[j].name] = ret[j];
                                notFound = false;
                            }
                        }
                    }
                    if (notFound) {
                        let formula = JSON.parse(JSON.stringify(ret[j]));
                        formula[ret[j].name] = ret[j];
                        formula.name = expand ? 'expand_sum' : 'video_sum';
                        customFormulaSums.push(formula);
                    }
                }
            }
            ret = ret.concat(customFormulaSums);
        }
        return ret;
    }
};

// actions
const actions = {
    async fetch({commit, state}, id) {
        try {
            state.changesMade = false;
            if (typeof state.dashboard.cache.find(x => x.id === id.id) === "undefined") {
                const {data} = await TrackingRepository.getTrackingList(id);
                if (Object.keys(data).length !== 0 && data.constructor === Object) {
                    data.spaces.forEach((space) => {
                        space.initial = true;
                        space.interactions.forEach((interaction) => {
                            interaction.initial = true;
                        });
                        space.modules.forEach((module) => {
                            module.initial = true;
                            module.interactions.forEach((modInteraction) => {
                                modInteraction.initial = true;
                            })
                        });
                    });
                    commit('setData', data);
                    commit('toggleCommentSection');
                }
            }
        } catch (e) {
            Vue.noty.error(e.message);
            console.error(e);
        }
    },
    async loadOtherTrackinglist({commit, state}, obj) {
        try {
            if (obj.id === null) {
                commit('updateTrackinglist', {type: "template", data: obj.data});
            } else {
                const {data} = await TrackingRepository.getTrackingList(obj.id);
                for (let i = 0; i < data.spaces.length; i++) {
                    let space = data.spaces[i];
                    for (let j = 0; j < space.interactions.length; j++) {
                        space.interactions[j].status = 'in Arbeit';
                    }
                    for (let j = 0; j < space.modules.length; j++) {
                        let module = space.modules[j];
                        for (let k = 0; k < module.interactions.length; k++) {
                            module.interactions[k].status = 'in Arbeit';
                        }
                    }
                }
                filterSpacesByType(data.spaces, state.data.medium.type);
                commit('updateTrackinglist', {type: "medium", data: data});
            }
        } catch (e) {
            Vue.noty.error(e.message);
            console.error(e);
        }
    },
    async updateLiveTrackingList({commit}) {
        try {
            state.data.formulas.forEach((formula) => {
                if (formula.pivot.description === 'Beschreibung editieren' || formula.pivot.description === '') {
                    formula.pivot.description = null;
                }
            });
            await TrackingRepository.updateTrackingList(state.data.id, state.data);
            commit('updateInitialStatus');
        } catch (e) {
            Vue.noty.error(e.message);
            console.error(e);
        }
    },
    async fetchReportings({commit}, {vm}) {
        if (state.reporting_loading !== true) state.reporting_loading = true;
        let insertionOrders = state.data.medium.insertion_order;
        let axiosRequests = [];
        for (let i = 0; i < insertionOrders.length; i++) {
            let hash = insertionOrders[i].engagement_hash;
            let minDate, maxDate;
            let dates = [];
            state.currentRoute = vm.$route.name
            if ((state.currentRoute === 'showDashboard' || state.currentRoute === 'showReporting') && typeof insertionOrders[i].dashboard_dates !== 'undefined' && insertionOrders[i].dashboard_dates.length > 0) {
                for (let j = 0; j < insertionOrders[i].dashboard_dates.length; j++) {
                    dates.push(moment(insertionOrders[i].dashboard_dates[j].start, 'YYYY-MM-DD'));
                    dates.push(moment(insertionOrders[i].dashboard_dates[j].end, 'YYYY-MM-DD'));
                }
            } else {
                for (let j = 0; j < insertionOrders[i].dates.length; j++) {
                    dates.push(moment(insertionOrders[i].dates[j].start, 'YYYY-MM-DD'));
                    dates.push(moment(insertionOrders[i].dates[j].end, 'YYYY-MM-DD'));
                }
            }
            if (dates.length !== 0) {
                let moments = dates.map(d => moment(d));
                maxDate = moment.max(moments);
                minDate = moment.min(moments);
                //let url = 'https://api-engagement2.adalliance.io/export/' + hash + '/' +
                let url = 'https://api-engagement2.adalliance.io/request/' + hash + '/' +
                    minDate.year() + '-' + ('0' + ((minDate.month() + 1))).slice(-2) + '-' + ('0' + ((minDate.date()))).slice(-2) + '/' +
                    maxDate.year() + '-' + ('0' + ((maxDate.month() + 1))).slice(-2) + '-' + ('0' + ((maxDate.date()))).slice(-2);

                if (location.origin.indexOf('localhost') !== -1) {
                    //url = 'https://api-engagement2.adalliance.io/export/' + hash + '/2020-11-06/2020-11-06';
                    url += '?local=2';
                } else if (location.origin.indexOf('engagement-tool-stage') !== -1) {
                    url += '?stage=2';
                } else if (location.origin.indexOf('engagement-tool') !== -1) {
                    url += '?live=2';
                }
                axiosRequests.push(url);
            }
        }
        try {
            let res = [];
            //get the retrieve IDs and save them to reportingData state
            for (let i = 0; i < axiosRequests.length; i++) {
                let resFetch = await fetch(axiosRequests[i], {
                    method: 'GET',
                    headers: {
                        'X-Api-Key': process.env.VUE_APP_API_KEY
                    }
                });
                let data = await resFetch.json();
                data.url = axiosRequests[i];
                data.retrieveId = data.result.retrieveId;
                data.result = null;
                data.insertion_order_id = insertionOrders[i].id;
                data.lineItems = insertionOrders[i].line_items;
                res = res.concat(data);
            }
            commit('setReportingData', res);

            //fetch data from retrievingIds every 10s if result = null
            for (let i = 0; i < state.reportingData.length; i++) {
                await fetchReportingResults(commit, i);
                if (state.reportingData[i].result === null) {
                    state.reportingData[i].intervalId = setInterval(async () => {
                        await fetchReportingResults(commit, i);
                    }, 10000);
                }
            }
        } catch (e) {
            Vue.noty.error('Fehler beim Abruf der Reporting Daten.');
            console.error(e);
        }
    }
};

// mutations
const mutations = {
    triggerFilter(state) {
        filterSpacesByType(state.data.spaces, state.data.medium.type);
    },
    updateInitialStatus(state) {
        state.initialStatus = state.data.status;
        if (state.changesMade) state.changesMade = false;
    },
    removeMediumStatus(state) {
        if (typeof state.data.medium.status !== "undefined") {
            delete state.data.medium.status;
        }
    },
    editSpace(state, data) {
        let target = state.data.spaces[data.spaceId];
        target.name = data.name;
        target.technical_name = data.technical_name;
    },
    moveSpaceUp(state, spaceIndex) {
        if (spaceIndex > 0) {
            arrayMove(state.data.spaces, spaceIndex, spaceIndex - 1);
        }
        if (!state.changesMade) state.changesMade = true;
    },
    moveSpaceDown(state, spaceIndex) {
        if (spaceIndex < state.data.spaces.length - 1) {
            arrayMove(state.data.spaces, spaceIndex, spaceIndex + 1);
        }
        if (!state.changesMade) state.changesMade = true;
    },
    moveModuleUp(state, data) {
        if (data.moduleId > 0) {
            arrayMove(state.data.spaces[data.spaceId].modules, data.moduleId, data.moduleId - 1);
        }
        if (!state.changesMade) state.changesMade = true;
    },
    moveModuleDown(state, data) {
        if (data.moduleId < state.data.spaces[data.spaceId].modules.length - 1) {
            arrayMove(state.data.spaces[data.spaceId].modules, data.moduleId, data.moduleId + 1);
        }
        if (!state.changesMade) state.changesMade = true;
    },
    setData(state, data) {
        state.data = data;
        state.initialStatus = data.status;
        let type = state.data.medium.type;
        filterSpacesByType(state.data.spaces, type);
    },
    updateTrackinglist(state, obj) {
        if (obj.type !== "template") {
            obj.data.formulas.forEach((formula) => {
                formula.pivot.tracking_list_id = state.data.id;
            });
            state.data.formulas = obj.data.formulas;
        }
        state.data.spaces = obj.data.spaces.sort(sortByPivot);
    },
    setReportingData(state, data) {
        state.reportingData = data;
    },
    setTableClientRect(state, rect) {
        state.tableClientRect = rect;
    },
    setContentContainerRect(state, rect) {
        state.contentContainerRect = rect;
    },
    setFormulaProperty(state, formula) {
        let index;
        if (formula.data.id === 1) { // customFormula
            index = state.data.formulas.findIndex(x => x.name.toLowerCase() === formula.data.name.toLowerCase() && x.spacename === formula.data.spacename)
        } else {
            index = state.data.formulas.findIndex(x => x.name.toLowerCase() === formula.data.name.toLowerCase());
        }
        if (formula.property === 'visibility') {
            state.data.formulas[index].pivot.visibility = formula.data.pivot.visibility === 'extern' ? 'intern' : 'extern';
        } else if (formula.property === 'pivot.description') {
            state.data.formulas[index].pivot.description = formula.value;
        } else if (formula.property === 'description') {
            Vue.set(state.data.formulas, index, formula.data);
            state.data.formulas[index].pivot.description = formula.data.pivot.description;
        }
        if (!state.changesMade) state.changesMade = true;
    },
    copySpace(state, index) {
        let original = state.data.spaces[index];
        let copy = JSON.parse(JSON.stringify(state.data.spaces[index]));
        let names = Utils.getNextNumberedNames(copy.name, copy.technical_name, index, state.data.spaces);
        copy.name = names.name;
        copy.technical_name = names.technical_name;
        copy.id = null;
        state.data.spaces.splice(names.insertIndex, 0, copy);
        let originalLastChar = original.name[original.name.length - 1];
        if (isNaN(originalLastChar)) {
            original.name += '1';
            original.technical_name += '1';
        }
        if (!state.changesMade) state.changesMade = true;
    },
    copyInteraction(state, data) {
        let interaction;
        let collection;
        if (data.moduleId !== null) {
            interaction = state.data.spaces[data.spaceId].modules[data.moduleId].interactions[data.interactionId];
            collection = state.data.spaces[data.spaceId].modules[data.moduleId].interactions;
        } else {
            interaction = state.data.spaces[data.spaceId].interactions[data.interactionId];
            collection = state.data.spaces[data.spaceId].interactions;
        }
        let copy = JSON.parse(JSON.stringify(interaction));
        let names = Utils.getNextNumberedNames(copy.name, copy.technical_name, data.interactionId, collection);
        copy.name = names.name;
        copy.technical_name = names.technical_name;
        collection.splice(names.insertIndex, 0, copy);
    },
    copyModule(state, data) {
        let original = state.data.spaces[data.spaceId].modules[data.moduleId];
        let copy = JSON.parse(JSON.stringify(original));
        let names = Utils.getNextNumberedNames(copy.name, copy.technical_name, data.moduleId, state.data.spaces[data.spaceId].modules);
        copy.name = names.name;
        copy.technical_name = names.technical_name;
        copy.id = null;
        state.data.spaces[data.spaceId].modules.splice(names.insertIndex, 0, copy);
        let originalLastChar = original.name[original.name.length - 1];
        if (isNaN(originalLastChar)) {
            original.name += '1';
            original.technical_name += '1';
        }
        if (!state.changesMade) state.changesMade = true;
    },
    addSpaces(state, spaces) {
        // only add space if not already exists
        for (let i = 0; i < spaces.length; i++) {
            let toAdd = spaces[i];
            let contains = false;
            for (let j = 0; j < state.data.spaces.length; j++) {
                let orig = state.data.spaces[j];
                if (orig.name === toAdd.name || orig.technical_name === toAdd.technical_name) {
                    contains = true;
                }
            }
            if (!contains) {
                for (let j = 0; j < toAdd.modules.length; j++) {
                    let module = toAdd.modules[j];
                    if (module.pivot.count > 1) {
                        for (let k = 0; k < module.pivot.count; k++) {
                            let copyMod = Object.assign({}, module);
                            copyMod.pivot.count = 1;
                            copyMod.name = copyMod.name + (k + 2);
                            copyMod.technical_name = copyMod.technical_name + (k + 2);
                            let copyInters = [];
                            for (let l = 0; l < module.interactions.length; l++) {
                                copyInters.push(Object.assign({}, module.interactions[l]));
                            }
                            copyMod.interactions = copyInters;
                            toAdd.modules.splice(j + 1, 0, copyMod);
                        }
                    }
                }
                toAdd.initial = false;
                if (toAdd.interactions.length !== 0) toAdd.interactions.sort(sortByPivot);
                toAdd.modules.sort(sortByPivot);
                toAdd.modules.forEach((module) => {
                    if (module.interactions.length !== 0) {
                        module.interactions.sort(sortByPivot);
                    }
                });
                state.data.spaces.push(toAdd);
                let interactions = getAllInteractions(state);
                setTrackinglistStatus(state, interactions);
                if (!state.changesMade) state.changesMade = true;
            } else {
                Vue.noty.error("Der Name oder der technische Name wird durch einen anderen Space belegt.");
            }
        }
    },
    addInteractionToSpace(state, data) {
        for (let i = 0; i < data.interactions.length; i++) {
            let inter = data.interactions[i];
            let collection = state.data.spaces[data.spaceId].interactions;
            let names = Utils.getNextNumberedNames(inter.name, inter.technical_name, collection.length - 1, collection);
            inter.name = names.name;
            inter.technical_name = names.technical_name;
            collection.splice(names.insertIndex, 0, inter);
        }
        let interactions = getAllInteractions(state);
        setTrackinglistStatus(state, interactions);
        if (!state.changesMade) state.changesMade = true;
    },
    addInteractionToModule(state, data) {
        for (let i = 0; i < data.interactions.length; i++) {
            let inter = data.interactions[i];
            let collection = state.data.spaces[data.spaceId].modules[data.moduleId].interactions;
            let names = Utils.getNextNumberedNames(inter.name, inter.technical_name, collection.length - 1, collection);
            inter.name = names.name;
            inter.technical_name = names.technical_name;
            collection.splice(names.insertIndex, 0, inter);
        }
        let interactions = getAllInteractions(state);
        setTrackinglistStatus(state, interactions);
        if (!state.changesMade) state.changesMade = true;
    },
    addModuleToSpace(state, data) {
        let modules = JSON.parse(JSON.stringify(data.modules));
        for (let i = 0; i < modules.length; i++) {
            let module = modules[i];
            let lastChar = module.name[module.name.length - 1];
            let name = module.name;
            let techName = module.technical_name;
            let lastCharTech = module.technical_name[module.technical_name.length - 1];
            if (!isNaN(lastChar)) {
                name = name.substring(0, name.length - 1);
            }
            if (!isNaN(lastCharTech)) {
                techName = techName.substring(0, techName.length - 1);
            }
            let nrOfDuplicates = 1;
            for (let j = 0; j < state.data.spaces[data.spaceId].modules.length; j++) {
                if (j === data.moduleId) continue;
                let mod = state.data.spaces[data.spaceId].modules[j];
                if (mod.name.includes(name) || mod.technical_name.includes(techName)) {
                    nrOfDuplicates += 1;
                }
            }
            module.name = name + (nrOfDuplicates > 1 ? nrOfDuplicates : '');
            module.technical_name = techName + (nrOfDuplicates > 1 ? nrOfDuplicates : '');
            module.interactions = module.interactions.sort(sortByPivot)
        }

        state.data.spaces[data.spaceId].modules = state.data.spaces[data.spaceId].modules.concat(modules);
        if (!state.changesMade) state.changesMade = true;
        let interactions = getAllInteractions(state);
        setTrackinglistStatus(state, interactions);
    },
    deleteSpace(state, index) {
        state.data.spaces.splice(index, 1);
        if (!state.changesMade) state.changesMade = true;
        let interactions = getAllInteractions(state);
        setTrackinglistStatus(state, interactions);
    },
    deleteModule(state, data) {
        state.data.spaces[data.spaceId].modules.splice(data.moduleId, 1);
        if (!state.changesMade) state.changesMade = true;
        let interactions = getAllInteractions(state);
        setTrackinglistStatus(state, interactions);
    },
    deleteInteraction(state, data) {
        if (data.spaceId == null) {
            state.data.interactions.splice(data.interactionId, 1);
        } else if (data.moduleId == null) {
            state.data.spaces[data.spaceId].interactions.splice(data.interactionId, 1);
        } else {
            state.data.spaces[data.spaceId].modules[data.moduleId].interactions.splice(data.interactionId, 1);
        }
        if (!state.changesMade) state.changesMade = true;
        let interactions = getAllInteractions(state);
        setTrackinglistStatus(state, interactions);
    },
    setContainerHeight(state, height) {
        state.containerHeight = height;
    },
    setInteractionProperty(state, data) {
        if (data.moduleIndex == null && data.spaceIndex == null) {
            state.data.interactions[data.interactionIndex][data.property] = data.value;
        } else if (data.moduleIndex != null) {
            state.data.spaces[data.spaceIndex].modules[data.moduleIndex].interactions[data.interactionIndex][data.property] = data.value;
        } else {
            state.data.spaces[data.spaceIndex].interactions[data.interactionIndex][data.property] = data.value;
        }

        if (data.property === "status") {
            let interactions = getAllInteractions(state);
            setTrackinglistStatus(state, interactions);
            state.showCommentSection = false;
            for (let i = 0; i < interactions.length; i++) {
                if (interactions[i].status === 'nicht eingebaut') {
                    state.showCommentSection = true;
                    break;
                }
            }
        }
        if (!state.changesMade) state.changesMade = true;
    },
    setModuleName(state, data) {
        state.data.spaces[data.spaceIndex].modules[data.moduleIndex].name = data.name;
        if (!state.changesMade) state.changesMade = true;
    },
    setSpaceName(state, data) {
        state.data.spaces[data.spaceIndex].name = data.name;
        if (!state.changesMade) state.changesMade = true;
    },
    clearData(state) {
        state.data = {medium: {insertion_order: []}};
        state.changesMade = false;
    },
    resetFormulaStandardEvent(state, eventName) {
        let index = state.formulaStandardEvents.findIndex(x => x.name === eventName);
        state.formulaStandardEvents[index].selected = false;
    },
    addFormula(state, formula) {
        state.data.formulas.push(formula);
        if (formula.pivot.description === null) {
            formula.pivot.description = state.formulaStandardEvents[state.formulaStandardEvents.findIndex(x => x.name === formula.name)].description;
        }
        state.changesMade = true;
    },
    removeFormula(state, formula) {
        let index = state.data.formulas.findIndex(x => x.pivot.name === formula.name);
        state.data.formulas.splice(index, 1);
        state.changesMade = true;
    },
    editFormula(state, formula) {
        let index = state.data.formulas.findIndex(x => x.name === formula.original.name && x.pivot.spacename === formula.original.spacename);
        state.data.formulas[index].pivot.spacename = formula.spacename;
        if (state.data.formulas[index].id === 1) {
            state.data.formulas[index].pivot.name = formula.name;
            state.data.formulas[index].pivot.dividend = formula.dividend;
            state.data.formulas[index].pivot.divisor = formula.divisor;
            state.data.formulas[index].pivot.description = formula.description;
            state.data.formulas[index].pivot.order = formula.order;
        }
        state.changesMade = true;
    },
    toggleCommentSection(state, show) {
        state.showCommentSection = false;
        if (typeof show !== "undefined" && show) {
            state.showCommentSection = true;
        } else {
            let allInteractions = getAllInteractions(state);
            for (let i = 0; i < allInteractions.length; i++) {
                if (allInteractions[i].status === 'nicht eingebaut') {
                    state.showCommentSection = true;
                    break;
                }
            }
        }

    }
};


async function fetchReportingResults(commit, index) {
    //fetch data from retrievingIds every 10s if result = null
    if (state.reporting_loading !== true) state.reporting_loading = true;
    let resfetch = await fetch('https://api-engagement2.adalliance.io/retrieve/' + state.reportingData[index].retrieveId +
        (location.origin.indexOf('localhost') !== -1 ? '?local=2' :
            (location.origin.indexOf('engagement-tool-stage') !== -1 ? '?stage=2' :
                (location.origin.indexOf('engagement-tool') !== -1 ? '?live=2' : ''))), {
        method: 'GET',
        headers: {
            'X-Api-Key': process.env.VUE_APP_API_KEY
        }
    });

    let data = await resfetch.json();
    console.log('[' + new Date().toLocaleTimeString() + '] ' + state.reportingData[index].retrieveId, data.result);
    if (data.status && data.result && data.result !== state.reportingData[index].result) {
        let res = JSON.parse(JSON.stringify(state.reportingData));
        res[index].result = data.result;
        clearInterval(state.reportingData[index].intervalId);
        state.reporting_loading = false;
        commit('setReportingData', res);
    }
}

function arrayMove(array, from, to) {
    array.splice(to, 0, array.splice(from, 1)[0]);
}

function getInsertionOrderOfHash(hash) {
    let insertion_order_id = parseInt(hash.split('_')[hash.split('_').length - 1]);
    let insertion_order = state.data.medium.insertion_order.find(x => x.id === insertion_order_id);
    if (insertion_order) {
        if (insertion_order.type.toLowerCase() === "festplatzierung" || insertion_order.type.toLowerCase() === "run of site") {
            insertion_order = state.data.medium.insertion_order;
        } else {
            insertion_order = [state.data.medium.insertion_order.find(x => x.engagement_hash === hash.split('_')[0])];
        }
    }
    return insertion_order;
}

/*
function getDetailsOfHash(hash) {
    let insertion_order = getInsertionOrderOfHash(hash);
    let lineitems = [];
    if (typeof insertion_order !== 'undefined') {
        for (let i = 0; i < insertion_order.length; i++) {
            lineitems.push(insertion_order[i].line_items);
        }
    }
    return {lineItems: lineitems};
}*/

function getSitesOfHash(hash, state) {
    let insertion_order = getInsertionOrderOfHash(hash);
    let sites = [];
    if (typeof insertion_order !== 'undefined') {
        for (let i = 0; i < insertion_order.length; i++) {
            let tmp_sites = insertion_order[i].sites;
            let tmp_dates = insertion_order[i].dates;
            if ((state.currentRoute === 'showDashboard' || state.currentRoute === 'showReporting') && typeof insertion_order[i].dashboard_dates !== 'undefined' && insertion_order[i].dashboard_dates.length > 0) {
                tmp_dates = insertion_order[i].dashboard_dates;
            }
            tmp_sites.forEach((site) => {
                site.dates = tmp_dates;
                site.type = insertion_order[i].type;
            });
            if (tmp_sites.length !== 0) sites.push(tmp_sites);
        }
    }
    return sites;
}

function getTotalCountOf(reporting, formulaType, state) {
    let ret = {};
    for (let hash in reporting) {
        try {
            ret[hash] = ret[hash] || {sites: [], line_items: reporting[hash].lineItems};
            //console.log('ret info:')
            //console.log(ret[hash]);
            let events = {};
            let sitesOfHash = getSitesOfHash(hash, state);
            let sites = sitesOfHash.length === 0 ? [] : sitesOfHash;

            if (sites.length === 0) {
                ret[hash].sites.push({
                    events: reporting[hash].events,
                    count: 0,
                });
                if (Array.isArray(formulaType) && formulaType.includes('totalClicks') || !Array.isArray(formulaType) && formulaType === 'totalClicks') {
                    for (let i = 0; i < reporting[hash].lineItems.length; i++) {
                        let clicks = Utils.calcClicks(reporting[hash].lineItems[i], state.data.medium.type);
                        ret[hash].sites[0].count += clicks.totalClicks;
                    }
                }
                for (let eventName in ret[hash].sites[0].events) {
                    let endsWith = Array.isArray(formulaType) ? endsWithAny(formulaType, eventName) : eventName.endsWith(formulaType);
                    if (endsWith) {
                        ret[hash].sites[0].count += ret[hash].sites[0].events[eventName];
                    }
                }

            } else {
                //sum all same named events
                sites.forEach((insertion_order) => {
                    let insertion_order_sites = {sites: [], count: 0};
                    insertion_order.forEach((site) => {
                        let siteName = site.code !== "" ? site.code : site.name;
                        let site_events;
                        if (site.parent_code) {
                            if (reporting[hash].categories[site.parent_code]) site_events = reporting[hash].categories[site.parent_code][siteName];
                        } else {
                            site_events = reporting[hash].sites[siteName];
                        }
                        for (let event in site_events) {
                            if (Object.prototype.hasOwnProperty.call(events, event)) {
                                events[event] += site_events[event];
                            } else {
                                events[event] = site_events[event];
                            }
                        }

                        let siteObj = JSON.parse(JSON.stringify(site));
                        siteObj.events = site_events;
                        siteObj.count = 0;
                        insertion_order_sites.sites.push(siteObj);
                    });
                    ret[hash].sites.push(insertion_order_sites);
                });

                //count required events

                for (let i = 0; i < ret[hash].sites.length; i++) {
                    let siteObj = ret[hash].sites[i];
                    for (let j = 0; j < siteObj.sites.length; j++) {
                        let site = siteObj.sites[j];
                        for (let eventName in site.events) {
                            let endsWith = Array.isArray(formulaType) ? endsWithAny(formulaType, eventName) : eventName.endsWith(formulaType);
                            if (endsWith) {
                                siteObj.count += site.events[eventName];
                                site.count += site.events[eventName];
                            }
                        }

                        siteObj.sites[j] = site;
                    }
                }
                if (Array.isArray(formulaType) && formulaType.includes('totalClicks') || !Array.isArray(formulaType) && formulaType === 'totalClicks') {
                    for (let i = 0; i < ret[hash].sites.length; i++) {
                        for (let k = 0; k < reporting[hash].lineItems.length; k++) {
                            let clicks = Utils.calcClicks(reporting[hash].lineItems[k], state.data.medium.type);
                            ret[hash].sites[i].count += clicks.totalClicks;
                        }
                    }
                }

            }
        } catch (e) {
            console.error(e);
        }
    }
    return ret;
}

function divideEachBy(reporting, dividend, divisor, eventName, isCustomFormula = false) {
    //
    let obj = JSON.parse(JSON.stringify(dividend));
    let divisor_copy = JSON.parse(JSON.stringify(divisor));
    for (let hash in obj) {
        try {
            for (let i = 0; i < obj[hash].sites.length; i++) {
                if (isCustomFormula) {
                    obj[hash].sites[i].count = divisor_copy[hash].sites[i].count !== 0 ? dividend[hash].sites[i].count / divisor_copy[hash].sites[i].count : 0;
                    obj[hash].sites[i].relation = '-';
                    obj[hash].sites[i].count = obj[hash].sites[i].count === 0 ? 0 : obj[hash].sites[i].count.toFixed(2).toLocaleString('de-DE').replace(".", ",");
                } else {
                    let insertion_order = obj[hash].sites[i];
                    let impressions = Utils.calcImpressions(obj[hash].line_items, state.data.medium.type);

                    let isZero = typeof divisor === "string" ? (impressions[divisor] === 0 || insertion_order.count === 0) : (divisor[hash].sites[i].count === 0);
                    let calcRelation = typeof divisor === "string" ? (insertion_order.count / impressions[divisor]) : (insertion_order.count / divisor_copy[hash].sites[i].count);

                    insertion_order.relation = isZero ? "0 %" : calcRelation;

                    if (typeof insertion_order.sites !== "undefined") {
                        insertion_order.sites.forEach((site) => {
                            let zeroCheck = typeof divisor === "string" ? (impressions[divisor] === 0 || site.count === 0) : (divisor[hash].sites[i].count === 0);
                            let siteRelation = typeof divisor === "string" ? (site.count / impressions[divisor]) : (site.count / (divisor_copy[hash].sites[i].sites.filter((x) => x.id === site.id)[0].count));
                            site.relation = zeroCheck ? '0 %' : siteRelation;
                        });
                    }

                    //change units and format numbers
                    if (eventName && typeof eventName !== "undefined" && (eventName.indexOf('time') !== -1)) {
                        insertion_order.count = insertion_order.count === 0 ? '0 s' : insertion_order.relation.toFixed(2).toLocaleString('de-DE').replace(".", ",") + ' s';
                        insertion_order.relation = '-';
                        if (typeof insertion_order.sites !== "undefined") {
                            insertion_order.sites.forEach((site) => {
                                site.count = site.count === 0 ? '0 s' : site.relation.toFixed(2).toLocaleString('de-DE').replace(".", ",") + ' s';
                                site.relation = '-';
                            });
                        }
                    } else if (insertion_order.relation !== '0 %') {
                        insertion_order.relation = (insertion_order.relation * 100).toFixed(2).toLocaleString('de-DE').replace(".", ",") + ' %';
                        if (typeof insertion_order.sites !== "undefined") {
                            insertion_order.sites.forEach((site) => {
                                if (site.relation !== '0 %') {
                                    site.relation = (site.relation * 100).toFixed(2).toLocaleString('de-DE').replace(".", ",") + ' %';
                                }
                            })
                        }
                    }

                }
                /*if (isCustomFormula) {
                    Object.keys(obj).forEach(hash => {
                        obj[hash].sites.forEach(site => {
                            site.count = isZero ? 0 : calcRelation.toFixed(2).toLocaleString('de-DE').replace(".", ",");
                        })
                    })
                }*/
            }
        } catch (e) {
            console.error(e);
        }
    }
    return obj;
}

function endsWithAny(suffixes, string) {
    return suffixes.some(function (suffix) {
        return string.endsWith(suffix);
    });
}

function isInteractionValid(inter, deviceType) {
    let valid = false;
    switch (deviceType.toLowerCase()) {
        case "online":
            if (inter.on_desktop === 1 || inter.on_tablet === 1) {
                valid = true;
            }
            break;
        case "desktop":
            if (inter.on_desktop === 1) {
                valid = true;
            }
            break;
        case "mobile":
            if (inter.on_mobile === 1) {
                valid = true;
            }
            break;
        case "tablet":
            if (inter.on_tablet === 1) {
                valid = true;
            }
            break;
    }
    return valid;
}

function filterSpacesByType(spaces, deviceType) {
    for (let i = 0; i < spaces.length; i++) {
        let space = spaces[i];
        let filteredInteractions = [];
        for (let j = 0; j < spaces[i].interactions.length; j++) {
            let inter = spaces[i].interactions[j];
            if (isInteractionValid(inter, deviceType)) {
                filteredInteractions.push(inter);
            }
        }
        for (let j = 0; j < spaces[i].modules.length; j++) {
            let module = spaces[i].modules[j];
            let filteredModuleInteractions = [];
            for (let k = 0; k < module.interactions.length; k++) {
                let inter = module.interactions[k];
                if (isInteractionValid(inter, deviceType)) {
                    filteredModuleInteractions.push(inter);
                }
            }
            module.interactions = filteredModuleInteractions;
        }
        space.interactions = filteredInteractions;
    }
}

function getAllInteractions(state) {
    let interactions = [];
    for (let i = 0; i < state.data.spaces.length; i++) {
        interactions = interactions.concat(state.data.spaces[i].interactions);
        state.data.spaces[i].modules.forEach((module) => {
            interactions = interactions.concat(module.interactions);
        })
    }
    return interactions;
}

function setTrackinglistStatus(state, interactions) {
    let currentStatus = '';
    let allSameStatus = true; // Do all interactions have the same status?
    let uniqueStatus = [];
    for (let i = 0; i < interactions.length; i++) {
        if (i === 0) {
            currentStatus = interactions[i].status === "nicht eingebaut" ? "eingebaut" : interactions[i].status;
            uniqueStatus.push(interactions[i].status);
        } else {
            if (interactions[i].status !== currentStatus) {
                if (!(interactions[i].status === "nicht eingebaut" && currentStatus === "eingebaut")) {
                    allSameStatus = false;
                    if (uniqueStatus.indexOf(interactions[i].status) === -1) {
                        uniqueStatus.push(interactions[i].status);
                    }
                }
            }
        }
    }
    if (allSameStatus) {
        if (state.data.status !== currentStatus) {
            state.data.status = currentStatus;
        }
    } else {
        if (uniqueStatus.indexOf('in Arbeit') !== -1) {
            state.data.status = 'in Arbeit';
        } else if (uniqueStatus.indexOf('gecheckt') !== -1) {
            state.data.status = 'gecheckt';
        } else if (uniqueStatus.indexOf('eingebaut') !== -1 || uniqueStatus.indexOf('nicht eingebaut') !== -1) {
            state.data.status = 'eingebaut';
        }
    }
}

function sortByPivot(a, b) {
    if (a.pivot.sort < b.pivot.sort) {
        return -1;
    }
    if (a.pivot.sort > b.pivot.sort) {
        return 1;
    }
    return 0;
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}